module.exports = __webpack_public_path__ + "static/media/phone.71616f16.svg";